import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
// import './css/default.css';
// import './css/main_new.css';
// import './css/reset.css';
// import './css/styles.css';

import Header from './component/header/Header';
import Shopping from './component/container/shopping/Shopping';
import Login from './component/container/login/Login';
import Home from './component/container/home/Home';
import Register from './component/container/user/Register';
import Place from './component/container/place/Place';
import FindInfo from './component/container/user/FindInfo';
import LeftBanner from './component/banner/LeftBanner';
import RightSidebar from './component/sidebar/RightSidebar';
import PlaceRank from './component/container/rank/place/PlaceRank';
import Order from './component/container/order/Order';
import PostWrite from './component/container/post/PostWrite';
import PostDetail from './component/container/post/PostDetail';
import MyPage from './component/container/mypage/MyPage';
import shoppingRank from './component/container/rank/shopping/ShoppingRank';
import Footer from './component/container/footer/Footer';
import Loading from './component/loading/Loading';
import Community from './component/container/community/Community';
import Consulting from './component/container/consulting/Consulting';
import Information from './component/container/information/Information';
import Qna from './component/container/qna/Qna';
import Program from './component/container/program/Program';
import Keywords from './component/container/keywords/Keywords';
import BottomNav from './component/container/footer/BottomNav';
import VisitorCheck from './component/container/visitorCheck/VisitorCheck';
import OpenAds from './component/container/openAds/OpenAds';
import { SearchAmount, RelateKeywords } from './component/container/searchAmount/SearchAmount';
import ScrollTop from './component/common/ScrollTop';
import CoupangRank from './component/container/rank/coupang/CoupangRank';
import NoticeBoard from './component/container/noticeBoard/NoticeBoard';
import Expert from './component/container/expert/Expert';
import ExportProduct from './component/container/product/ExpertProduct';
import ExpertDetail from './component/container/expert/ExpertDetail';
import ExpertWrite from './component/container/expert/ExpertWrite';
import ExpertAdRequest from './component/container/expert/ExpertAdRequest';
import MainAdPop from './component/popup/MainAdPop';
import BoardAside from './component/sidebar/BoardAside';
import MembershipAside from './component/sidebar/MembershipAside';
import Membership from './component/container/membership/Membership';
import MarketingCompare from './component/container/marketingCompare/MarketingCompare';
import AdBannerAdmin from './component/container/admin/AdBannerAdmin';
import ImageUploadTestRedirect from './component/container/admin/ImageUploadTestRedirect';

import { UserProvider } from './context/UserContext';
import { MembershipProvider } from './context/MembershipContext';
import ShortCut from './component/container/home/ShortCut';

const buildContentComponent = Comp => {
  return (
    <div className="vh-content-wrap bg_white">
      <div className="vh-content-inner vw-inner">
          <Comp />
      </div>
    </div>
  )
}

const buildContentWithAsideComponent = (Comp, Aside = BoardAside) => {
  return (
    <div className="vh-content-wrap bg_white">
      <div className="vh-content-inner vw-inner">
          <Comp />
          <Aside />
      </div>
    </div>
  )
}

const buildNormalComponent = Comp => {
  return (
    <div className="vh-content-wrap bg_white">
      <div className="vh-content">
          <Comp />
          {/* <RightSidebar /> */}
      </div>
      <ShortCut />
    </div>
  )
}


{/* <div className='contents'>
        <div className='main'>
          <LeftBanner className='pc-only' />
          <Comp />
          <br className='mobile-only' />
          <LeftBanner className='mobile-only' selector='.main-left-banner-mobile' />
          <RightSidebar />
        </div>
      </div> */}


const buildNoBannerComponent = Comp => {
  return (
    <div className='contents_login' style={{display: 'block'}}>
      <Comp />
    </div>
  )
}

function App() {
  return (
    <UserProvider>
      <MembershipProvider>
      <div class="vh-container">
        <Router>
          <Header />
          <Routes>
            <Route path="/" element={buildNormalComponent(Home)} />
            <Route path="/consulting" element={buildContentWithAsideComponent(Consulting, () => <BoardAside showMembership={true} />)}>
              <Route path="/consulting/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/openads" element={buildNormalComponent(OpenAds)}>
              <Route path="/openads/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/community" element={buildContentWithAsideComponent(Community)}>
              <Route path="/community/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/free-community" element={buildContentWithAsideComponent(() => <Community postType='PT011' />)}>
              <Route path="/free-community/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/anon-community" element={buildContentWithAsideComponent(() => <Community postType='PT010' />)}>
              <Route path="/anon-community/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/information" element={buildContentWithAsideComponent(Information)}>
              <Route path="/information/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/qna" element={buildContentWithAsideComponent(Qna)}>
              <Route path="/qna/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/program" element={buildContentWithAsideComponent(Program)}>
              <Route path="/program/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/notice" element={buildContentWithAsideComponent(NoticeBoard)}>
              <Route path="/notice/post/detail/:postId" element={<PostDetail />} />  
            </Route>
            <Route path="/expert" element={buildContentComponent(Expert)}>
              <Route path="/expert/product/:productId" element={<ExportProduct />} />  
            </Route>
            <Route path="/expert/detail/:expertProductOwnerId" element={buildContentComponent(ExpertDetail)} />
            <Route path="/expert/productWrite/:productId" element={buildContentComponent(ExpertWrite)} />
            <Route path="/placeRank" element={buildContentComponent(PlaceRank)} />
            <Route path="/placeOnce" element={buildContentComponent(Place)} />
            <Route path="/shoppingRank" element={buildContentComponent(shoppingRank)} />
            <Route path="/shoppingOnce" element={buildContentComponent(Shopping)} />
            <Route path="/keywordsOnce" element={buildContentComponent(Keywords)} />
            <Route path="/visitorCheck" element={buildContentComponent(VisitorCheck)} />
            <Route path="/searchAmount" element={buildContentComponent(SearchAmount)} />
            <Route path="/relateKeywords" element={buildContentComponent(RelateKeywords)} />
            <Route path="/coupangRank" element={buildContentComponent(CoupangRank)} />
            <Route path="/order" element={buildContentComponent(Order)} />
            <Route path="/post/write" element={buildContentComponent(PostWrite)} />
            <Route path="/post/write/:postId" element={buildContentComponent(PostWrite)} />
            <Route path="/mypage/:tab" element={buildContentComponent(MyPage)} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={buildNoBannerComponent(Register)} />
            <Route path="/findInfo" element={buildNoBannerComponent(FindInfo)} />
            <Route path="/expert/adRequest" element={buildContentComponent(ExpertAdRequest)} />
            <Route path="/marketingCompare" element={buildContentComponent(MarketingCompare)} />
            <Route path="/membership" element={buildContentWithAsideComponent(Membership, MembershipAside)} />
            <Route path="/admin/ad-banners" element={buildContentComponent(AdBannerAdmin)} />
            <Route path="/imageUploadTest" element={buildContentComponent(ImageUploadTestRedirect)} />
          </Routes>
          <ScrollTop />
          <Footer />
          <BottomNav />
          <Loading />
          {/* <MainAdPop /> */}
        </Router>
      </div>
      </MembershipProvider>
    </UserProvider>
  );
}

export default App;

